import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Get language from localStorage or default to English
    return localStorage.getItem('selectedLanguage') || 'en';
  });

  const [direction, setDirection] = useState(language === 'ar' ? 'rtl' : 'ltr');

  // Update document direction and save to localStorage when language changes
  useEffect(() => {
    const newDirection = language === 'ar' ? 'rtl' : 'ltr';
    setDirection(newDirection);
    
    // Update HTML direction
    document.documentElement.dir = newDirection;
    document.documentElement.lang = language;
    
    // Save to localStorage
    localStorage.setItem('selectedLanguage', language);
    
    // Load appropriate font for Arabic
    if (language === 'ar') {
      // Load Changa font for Arabic
      const link = document.createElement('link');
      link.href = 'https://fonts.googleapis.com/css2?family=Changa:wght@400;700&display=swap';
      link.rel = 'stylesheet';
      if (!document.head.querySelector(`link[href="${link.href}"]`)) {
        document.head.appendChild(link);
      }
    }
  }, [language]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'en' ? 'ar' : 'en');
  };

  const switchToLanguage = (lang) => {
    if (['en', 'ar'].includes(lang)) {
      setLanguage(lang);
    }
  };

  const value = {
    language,
    direction,
    isArabic: language === 'ar',
    isEnglish: language === 'en',
    toggleLanguage,
    switchToLanguage
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};